import { render, staticRenderFns } from "./ForgotComponent.vue?vue&type=template&id=7e75af9d&"
import script from "./ForgotComponent.vue?vue&type=script&lang=js&"
export * from "./ForgotComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports